import { Image, Text, View } from "@react-pdf/renderer";
import { Style } from "@react-pdf/types";
import circularChartImage from "app/assets/CircularChart.png";
import React from "react";
import { TFunction } from "react-i18next";
import { LOAD_DISTRIBUTION_PDF_MANUAL_WEIGHING } from "../../data";
import { LoadDistributionPdfData } from "../../types";
import { formatPdfLabel, resolvePdfValue } from "./InfoCard";
import { withLastRowStyle } from "./Tables";
import { pdfStyles } from "./styles";

const PdfTableHeaderCells = ({
  labels,
  cellStyle,
}: {
  labels: string[];
  cellStyle: Style;
}) => (
  <View style={pdfStyles.pdfTableHeaderRow}>
    {labels.map((label) => (
      <Text key={label} style={cellStyle}>
        {label}
      </Text>
    ))}
  </View>
);

type PdfWeighingScreenProps = {
  t: TFunction;
  pdfData: LoadDistributionPdfData;
};

export const PdfWeighingScreen = ({ t, pdfData }: PdfWeighingScreenProps) => {
  const { manualWeighingForm, fuelInfo } = pdfData;
  const { COLUMNS, ROWS, TITLE, FILLER_NAME_LABEL } = LOAD_DISTRIBUTION_PDF_MANUAL_WEIGHING;

  return (
    <View style={pdfStyles.manualWeighingSection}>
      <Text style={pdfStyles.manualWeighingTitle}>{t(TITLE)}</Text>
      <Text style={pdfStyles.manualWeighingFillerLabel}>{t(FILLER_NAME_LABEL)}</Text>

      <View style={pdfStyles.pdfTable}>
        <PdfTableHeaderCells
          labels={[t(COLUMNS.REAR), t(COLUMNS.GENERAL), t(COLUMNS.FRONT)]}
          cellStyle={pdfStyles.pdfTableHeaderCell}
        />
        {manualWeighingForm.rows.map((row, index) => {
          const value = t(row.valueKey);
          const useLtr = row.valueKey === ROWS.KG || row.valueKey === ROWS.EMPTY;
          const cellStyle = useLtr ? pdfStyles.pdfTableValueCellLgLtr : pdfStyles.pdfTableValueCellLg;

          return (
            <View
              key={row.valueKey}
              style={withLastRowStyle(
                pdfStyles.pdfTableBodyRow,
                pdfStyles.pdfTableBodyRowLast,
                index === manualWeighingForm.rows.length - 1
              )}
            >
              <Text style={cellStyle}>{value}</Text>
              <Text style={cellStyle}>{value}</Text>
              <Text style={cellStyle}>{value}</Text>
            </View>
          );
        })}
      </View>

      <View style={pdfStyles.fuelInfoSection}>
        <View style={pdfStyles.fuelInfoOuterWrap}>
          <View style={pdfStyles.fuelInfoFieldsWrap}>
            {fuelInfo.fields.map((field) => (
              <View key={field.labelKey} style={pdfStyles.fuelInfoFieldRow}>
                <Text
                  style={field.ltr ? pdfStyles.pdfMetaValueLtr : pdfStyles.pdfMetaValue}
                >
                  {resolvePdfValue(field.valueKey, t)}
                </Text>
                <Text style={pdfStyles.pdfMetaLabel}>{formatPdfLabel(t(field.labelKey))}</Text>
              </View>
            ))}
          </View>
          <View style={pdfStyles.fuelInfoChartColumn}>
            <Image src={circularChartImage} style={pdfStyles.fuelInfoChartImage} />
          </View>
        </View>
      </View>
    </View>
  );
};
